export default __webpack_public_path__ + "static/media/dummy-agency.0fad305a.png";